// components/GenericChart.tsx
import React from 'react';
import {
  ArcElement,
  BarController,
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  ChartData,
  ChartOptions,
  ChartType,
  DoughnutController,
  Legend,
  LinearScale,
  LineController,
  LineElement,
  PointElement,
  Tooltip,
} from 'chart.js';
import { Chart } from 'react-chartjs-2';
import { styled } from '@mui/material';

// Register all chart controllers you’ll use
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  ArcElement,
  Tooltip,
  Legend,
  DoughnutController,
  BarController,
  LineController,
  LineElement,
  PointElement
);

export interface GenericChartProps<T extends ChartType> {
  type: T;
  data: ChartData<T>;
  options?: ChartOptions<T>;
  width?: number | string;
  height?: number | string;
}

const ChartContainer = styled('div')({
  display: 'flex',
  justifyContent: 'center',
});

export default function GenericChart<T extends ChartType>({
  type,
  data,
  options,
  width = '100%',
  height = '100%',
}: GenericChartProps<T>): JSX.Element {
  return (
    <ChartContainer style={{ width, height }}>
      <Chart type={type} data={data} options={options} />
    </ChartContainer>
  );
}
